import ReactECharts from "echarts-for-react";
import { useTranslation } from "react-i18next";
import BLUE_SHADES from "../constants/chartColors";

export default function AttendanceSparkLine({ summaries }) {
  const { t } = useTranslation();

  if (!summaries || summaries.length === 0) return null;
  summaries = summaries.sort((a, b) => new Date(a.DateUTC) - new Date(b.DateUTC))
  const data = summaries.map(s => s.totalHours);

  const option = {
    tooltip: {
      trigger: "axis",
      z: 9999,
      appendToBody: true,
      backgroundColor: "#1f2937",
      borderColor: "#374151",
      textStyle: { color: "#fff" },
      formatter: function (params) {
        const i = params[0].dataIndex;
        const s = summaries[i];

        return `
          <b>${s.DateLocal}</b><br/>
          ${t('hours')}: ${s.totalHours} / ${s.expectedWorkingHours}<br/>
          ${t('dueHoursShort')}: ${s.totalDueHours}<br/>
          ${t('overtime')}: ${s.totalOverTimeHours}<br/>
          ${t('lateMinutes')}: ${s.avgLateMinutes || 0} ${t('minutes')}
        `;
      }
    },

    grid: { left: 0, right: 0, top: 5, bottom: 5 },

    xAxis: {
      type: "category",
      show: false,
      data: summaries.map(s => s.DateLocal)
    },

    yAxis: {
      type: "value",
      show: false
    },

    series: [
      {
        data,
        type: "line",
        smooth: true,
        symbol: "circle",
        symbolSize: 6,
        lineStyle: {
          width: 2,
          color: "#ffffff"
        },
        itemStyle: {
          color: "#ffffff"
        },
        areaStyle: {
          opacity: 0.15
        }
      }
    ]
  };

  return (
    <ReactECharts
      option={option}
      style={{ height: 40, width: 120 }}
      opts={{ renderer: "svg" }}
    />
  );
}